<template>
  <div class="row" v-if="cars.length > 0">
    <car-list-car v-for="car in sortedCars" :key="car.key" :car="car"></car-list-car>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CarListCar from "@/components/CarListCar_v2.vue";
export default {
  computed: {
    ...mapGetters({
      cars: "getCars"
    }),
    sortedCars() {
      let c = window._.sortBy(this.cars, o => o.order_column);
      c = c.filter(car => {
        return car.public === 1;
      });
      c = c.filter(car => {
        return car.has_template;
      });
      return c;
    }
  },
  components: {
    CarListCar
  }
};
</script>

<style>
</style>
